import { type FC, useEffect, useState } from 'react';
import { FaHome, FaChartLine, FaNetworkWired, FaBell, FaChevronDown } from 'react-icons/fa';

const timeFormatter = new Intl.DateTimeFormat('es-ES', {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});

const utcFormatter = new Intl.DateTimeFormat('es-ES', {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
  timeZone: 'UTC',
});

const DevHeader: FC = () => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      style={{
        width: '100%',
        height: 'var(--core-header-height)',
        backgroundColor: '#D7192D',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: '12px',
        paddingRight: '12px',
        color: '#FFFFFF',
        fontSize: '12px',
        fontFamily: 'sans-serif',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
        <div
          style={{
            width: 36,
            height: 36,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <FaHome style={{ width: 20, height: 20, fontSize: 20 }} />
        </div>
        <div style={{ lineHeight: 1.3, fontVariantNumeric: 'tabular-nums' }}>
          <div style={{ fontWeight: 600 }}>
            {timeFormatter.format(now)}&nbsp;&nbsp;
            <span style={{ opacity: 0.8, fontWeight: 400 }}>LT</span>
          </div>
          <div style={{ fontWeight: 600 }}>
            {utcFormatter.format(now)}&nbsp;&nbsp;
            <span style={{ opacity: 0.8, fontWeight: 400 }}>UTC</span>
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <FaChartLine style={{ width: 20, height: 20, fontSize: 20 }} />
        <FaNetworkWired style={{ width: 20, height: 20, fontSize: 20 }} />
        <FaBell style={{ width: 20, height: 20, fontSize: 20 }} />

        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <div
            style={{
              width: 32,
              height: 32,
              borderRadius: '50%',
              border: '2px solid white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '13px',
              fontWeight: 700,
              letterSpacing: '0.5px',
            }}
          >
            IB
          </div>
          <FaChevronDown style={{ width: 12, height: 12, fontSize: 12 }} />
        </div>
      </div>
    </div>
  );
};

export default DevHeader;
